const symbols = {
  count: 100,
  total: 505,
  data: [
    {
      symbol: 'A',
      symbolName: 'Agilent Technologies',
      lastPrice: '84.01',
      priceChange: '-0.81',
      percentChange: '-0.95%',
      highPrice: '84.79',
      lowPrice: '84.01',
      volume: '6,115',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'A',
        symbolName: 'Agilent Technologies',
        lastPrice: 84.01,
        priceChange: -0.81,
        percentChange: -0.0095,
        highPrice: 84.79,
        lowPrice: 84.01,
        volume: 6115,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AAL',
      symbolName: 'American Airlines Gp',
      lastPrice: '28.01',
      priceChange: '-0.29',
      percentChange: '-1.02%',
      highPrice: '28.19',
      lowPrice: '28.01',
      volume: '21,567',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AAL',
        symbolName: 'American Airlines Gp',
        lastPrice: 28.01,
        priceChange: -0.29,
        percentChange: -0.0102,
        highPrice: 28.19,
        lowPrice: 28.01,
        volume: 21567,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AAP',
      symbolName: 'Advance Auto Parts Inc',
      lastPrice: '133.20',
      priceChange: '-1.17',
      percentChange: '-0.87%',
      highPrice: '133.35',
      lowPrice: '133.20',
      volume: '950',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AAP',
        symbolName: 'Advance Auto Parts Inc',
        lastPrice: 133.2,
        priceChange: -1.17,
        percentChange: -0.0087,
        highPrice: 133.35,
        lowPrice: 133.2,
        volume: 950,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AAPL',
      symbolName: 'Apple Inc',
      lastPrice: '320.78',
      priceChange: '-4.43',
      percentChange: '-1.36%',
      highPrice: '322.63',
      lowPrice: '320.78',
      volume: '515,304',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AAPL',
        symbolName: 'Apple Inc',
        lastPrice: 320.78,
        priceChange: -4.43,
        percentChange: -0.013600000000000001,
        highPrice: 322.63,
        lowPrice: 320.78,
        volume: 515304,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ABBV',
      symbolName: 'Abbvie Inc',
      lastPrice: '89.75',
      priceChange: '+2.57',
      percentChange: '+2.95%',
      highPrice: '90.03',
      lowPrice: '88.92',
      volume: '440,076',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ABBV',
        symbolName: 'Abbvie Inc',
        lastPrice: 89.75,
        priceChange: 2.57,
        percentChange: 0.029500000000000002,
        highPrice: 90.03,
        lowPrice: 88.92,
        volume: 440076,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ABC',
      symbolName: 'Amerisourcebergen Corp',
      lastPrice: '94.43',
      priceChange: '+1.95',
      percentChange: '+2.11%',
      highPrice: '94.43',
      lowPrice: '93.45',
      volume: '9,592',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ABC',
        symbolName: 'Amerisourcebergen Corp',
        lastPrice: 94.43,
        priceChange: 1.95,
        percentChange: 0.021099999999999997,
        highPrice: 94.43,
        lowPrice: 93.45,
        volume: 9592,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ABMD',
      symbolName: 'Abiomed Inc',
      lastPrice: '191.61',
      priceChange: '-4.40',
      percentChange: '-2.24%',
      highPrice: '193.04',
      lowPrice: '191.36',
      volume: '725',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ABMD',
        symbolName: 'Abiomed Inc',
        lastPrice: 191.61,
        priceChange: -4.4,
        percentChange: -0.022400000000000003,
        highPrice: 193.04,
        lowPrice: 191.36,
        volume: 725,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ABT',
      symbolName: 'Abbott Laboratories',
      lastPrice: '89.45',
      priceChange: '-0.02',
      percentChange: '-0.02%',
      highPrice: '89.45',
      lowPrice: '89.16',
      volume: '1,362',
      tradeTime: '09:32 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ABT',
        symbolName: 'Abbott Laboratories',
        lastPrice: 89.45,
        priceChange: -0.02,
        percentChange: -0.0002,
        highPrice: 89.45,
        lowPrice: 89.16,
        volume: 1362,
        tradeTime: 1581085920,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ACN',
      symbolName: 'Accenture Plc',
      lastPrice: '212.60',
      priceChange: '-1.56',
      percentChange: '-0.73%',
      highPrice: '213.20',
      lowPrice: '212.60',
      volume: '748',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ACN',
        symbolName: 'Accenture Plc',
        lastPrice: 212.6,
        priceChange: -1.56,
        percentChange: -0.0073,
        highPrice: 213.2,
        lowPrice: 212.6,
        volume: 748,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ADBE',
      symbolName: 'Adobe Systems Inc',
      lastPrice: '366.49',
      priceChange: '-0.96',
      percentChange: '-0.26%',
      highPrice: '366.82',
      lowPrice: '365.95',
      volume: '6,114',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ADBE',
        symbolName: 'Adobe Systems Inc',
        lastPrice: 366.49,
        priceChange: -0.96,
        percentChange: -0.0026,
        highPrice: 366.82,
        lowPrice: 365.95,
        volume: 6114,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ADI',
      symbolName: 'Analog Devices',
      lastPrice: '114.84',
      priceChange: '-0.95',
      percentChange: '-0.82%',
      highPrice: '114.97',
      lowPrice: '114.52',
      volume: '997',
      tradeTime: '09:33 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ADI',
        symbolName: 'Analog Devices',
        lastPrice: 114.84,
        priceChange: -0.95,
        percentChange: -0.008199999999999999,
        highPrice: 114.97,
        lowPrice: 114.52,
        volume: 997,
        tradeTime: 1581085980,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ADM',
      symbolName: 'Archer Daniels Midland',
      lastPrice: '45.73',
      priceChange: '-0.25',
      percentChange: '-0.54%',
      highPrice: '45.79',
      lowPrice: '45.63',
      volume: '4,108',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ADM',
        symbolName: 'Archer Daniels Midland',
        lastPrice: 45.73,
        priceChange: -0.25,
        percentChange: -0.0054,
        highPrice: 45.79,
        lowPrice: 45.63,
        volume: 4108,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ADP',
      symbolName: 'Automatic Data Procs',
      lastPrice: '178.64',
      priceChange: '-1.62',
      percentChange: '-0.90%',
      highPrice: '178.86',
      lowPrice: '178.56',
      volume: '2,762',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ADP',
        symbolName: 'Automatic Data Procs',
        lastPrice: 178.64,
        priceChange: -1.62,
        percentChange: -0.009000000000000001,
        highPrice: 178.86,
        lowPrice: 178.56,
        volume: 2762,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ADS',
      symbolName: 'Alliance Data Systems Corp',
      lastPrice: '105.46',
      priceChange: '-1.04',
      percentChange: '-0.98%',
      highPrice: '105.65',
      lowPrice: '105.46',
      volume: '6,070',
      tradeTime: '09:30 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ADS',
        symbolName: 'Alliance Data Systems Corp',
        lastPrice: 105.46,
        priceChange: -1.0400000000000063,
        percentChange: -0.0097652582159625,
        highPrice: 105.65,
        lowPrice: 105.46,
        volume: 6070,
        tradeTime: 1581085856,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ADSK',
      symbolName: 'Autodesk Inc',
      lastPrice: '205.50',
      priceChange: '-0.50',
      percentChange: '-0.24%',
      highPrice: '206.87',
      lowPrice: '205.50',
      volume: '10,008',
      tradeTime: '09:30 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ADSK',
        symbolName: 'Autodesk Inc',
        lastPrice: 205.5,
        priceChange: -0.5,
        percentChange: -0.0024271844660194173,
        highPrice: 206.87,
        lowPrice: 205.5,
        volume: 10008,
        tradeTime: 1581085858,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AEE',
      symbolName: 'Ameren Corp',
      lastPrice: '83.33',
      priceChange: '+0.16',
      percentChange: '+0.19%',
      highPrice: '83.43',
      lowPrice: '83.31',
      volume: '1,219',
      tradeTime: '09:32 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AEE',
        symbolName: 'Ameren Corp',
        lastPrice: 83.33,
        priceChange: 0.16,
        percentChange: 0.0019,
        highPrice: 83.43,
        lowPrice: 83.31,
        volume: 1219,
        tradeTime: 1581085920,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AEP',
      symbolName: 'American Electric Power Company',
      lastPrice: '101.96',
      priceChange: '-0.29',
      percentChange: '-0.28%',
      highPrice: '102.08',
      lowPrice: '101.96',
      volume: '1,245',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AEP',
        symbolName: 'American Electric Power Company',
        lastPrice: 101.96,
        priceChange: -0.29,
        percentChange: -0.0028000000000000004,
        highPrice: 102.08,
        lowPrice: 101.96,
        volume: 1245,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AES',
      symbolName: 'The Aes Corp',
      lastPrice: '20.56',
      priceChange: '-0.02',
      percentChange: '-0.10%',
      highPrice: '20.60',
      lowPrice: '20.55',
      volume: '17,862',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AES',
        symbolName: 'The Aes Corp',
        lastPrice: 20.56,
        priceChange: -0.02,
        percentChange: -0.001,
        highPrice: 20.6,
        lowPrice: 20.55,
        volume: 17862,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AFL',
      symbolName: 'Aflac Incorporated',
      lastPrice: '52.78',
      priceChange: '+0.04',
      percentChange: '+0.09%',
      highPrice: '52.83',
      lowPrice: '52.69',
      volume: '2,330',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AFL',
        symbolName: 'Aflac Incorporated',
        lastPrice: 52.78,
        priceChange: 0.04,
        percentChange: 0.0009,
        highPrice: 52.83,
        lowPrice: 52.69,
        volume: 2330,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AGN',
      symbolName: 'Allergan Plc',
      lastPrice: '195.10',
      priceChange: '+2.22',
      percentChange: '+1.15%',
      highPrice: '195.24',
      lowPrice: '194.16',
      volume: '145,518',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AGN',
        symbolName: 'Allergan Plc',
        lastPrice: 195.1,
        priceChange: 2.22,
        percentChange: 0.0115,
        highPrice: 195.24,
        lowPrice: 194.16,
        volume: 145518,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AIG',
      symbolName: 'American International Group',
      lastPrice: '53.08',
      priceChange: '-0.33',
      percentChange: '-0.62%',
      highPrice: '53.12',
      lowPrice: '53.03',
      volume: '1,545',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AIG',
        symbolName: 'American International Group',
        lastPrice: 53.08,
        priceChange: -0.33,
        percentChange: -0.0062,
        highPrice: 53.12,
        lowPrice: 53.03,
        volume: 1545,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AIV',
      symbolName: 'Apartment Investment and Management',
      lastPrice: '53.39',
      priceChange: '-0.10',
      percentChange: '-0.19%',
      highPrice: '53.55',
      lowPrice: '53.39',
      volume: '295',
      tradeTime: '09:31 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AIV',
        symbolName: 'Apartment Investment and Management',
        lastPrice: 53.39,
        priceChange: -0.1,
        percentChange: -0.0019,
        highPrice: 53.55,
        lowPrice: 53.39,
        volume: 295,
        tradeTime: 1581085860,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AIZ',
      symbolName: 'Assurant Inc',
      lastPrice: '135.74',
      priceChange: '-0.55',
      percentChange: '-0.40%',
      highPrice: '135.74',
      lowPrice: '135.74',
      volume: '1,459',
      tradeTime: '09:30 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AIZ',
        symbolName: 'Assurant Inc',
        lastPrice: 135.74,
        priceChange: -0.549999999999983,
        percentChange: -0.004035512510088656,
        highPrice: 135.74,
        lowPrice: 135.74,
        volume: 1459,
        tradeTime: 1581085820,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AJG',
      symbolName: 'Arthur J. Gallagher & Company',
      lastPrice: '105.24',
      priceChange: '+0.11',
      percentChange: '+0.11%',
      highPrice: '105.24',
      lowPrice: '105.24',
      volume: '112',
      tradeTime: '09:32 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AJG',
        symbolName: 'Arthur J. Gallagher & Company',
        lastPrice: 105.24,
        priceChange: 0.11,
        percentChange: 0.0011,
        highPrice: 105.24,
        lowPrice: 105.24,
        volume: 112,
        tradeTime: 1581085920,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AKAM',
      symbolName: 'Akamai Technologies',
      lastPrice: '96.36',
      priceChange: '-0.59',
      percentChange: '-0.61%',
      highPrice: '96.46',
      lowPrice: '96.34',
      volume: '1,007',
      tradeTime: '09:32 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AKAM',
        symbolName: 'Akamai Technologies',
        lastPrice: 96.36,
        priceChange: -0.59,
        percentChange: -0.0060999999999999995,
        highPrice: 96.46,
        lowPrice: 96.34,
        volume: 1007,
        tradeTime: 1581085920,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ALB',
      symbolName: 'Albemarle Corp',
      lastPrice: '83.50',
      priceChange: '-3.45',
      percentChange: '-3.97%',
      highPrice: '84.71',
      lowPrice: '83.50',
      volume: '8,204',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ALB',
        symbolName: 'Albemarle Corp',
        lastPrice: 83.5,
        priceChange: -3.45,
        percentChange: -0.0397,
        highPrice: 84.71,
        lowPrice: 83.5,
        volume: 8204,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ALGN',
      symbolName: 'Align Technology',
      lastPrice: '263.80',
      priceChange: '-2.96',
      percentChange: '-1.11%',
      highPrice: '264.51',
      lowPrice: '263.63',
      volume: '815',
      tradeTime: '09:33 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ALGN',
        symbolName: 'Align Technology',
        lastPrice: 263.8,
        priceChange: -2.96,
        percentChange: -0.0111,
        highPrice: 264.51,
        lowPrice: 263.63,
        volume: 815,
        tradeTime: 1581085980,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ALK',
      symbolName: 'Alaska Air Group',
      lastPrice: '64.07',
      priceChange: '+0.05',
      percentChange: '+0.08%',
      highPrice: '64.19',
      lowPrice: '63.94',
      volume: '3,446',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ALK',
        symbolName: 'Alaska Air Group',
        lastPrice: 64.07,
        priceChange: 0.05,
        percentChange: 0.0008,
        highPrice: 64.19,
        lowPrice: 63.94,
        volume: 3446,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ALL',
      symbolName: 'Allstate Corp',
      lastPrice: '124.00',
      priceChange: '+0.11',
      percentChange: '+0.08%',
      highPrice: '124.01',
      lowPrice: '123.75',
      volume: '6,379',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ALL',
        symbolName: 'Allstate Corp',
        lastPrice: 124,
        priceChange: 0.11,
        percentChange: 0.0008,
        highPrice: 124.01,
        lowPrice: 123.75,
        volume: 6379,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ALLE',
      symbolName: 'Allegion Plc',
      lastPrice: '132.51',
      priceChange: '+0.10',
      percentChange: '+0.07%',
      highPrice: '132.51',
      lowPrice: '132.21',
      volume: '1,472',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ALLE',
        symbolName: 'Allegion Plc',
        lastPrice: 132.51,
        priceChange: 0.1,
        percentChange: 0.0007000000000000001,
        highPrice: 132.51,
        lowPrice: 132.21,
        volume: 1472,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ALXN',
      symbolName: 'Alexion Pharm Inc',
      lastPrice: '103.28',
      priceChange: '-0.76',
      percentChange: '-0.73%',
      highPrice: '103.39',
      lowPrice: '102.97',
      volume: '3,606',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ALXN',
        symbolName: 'Alexion Pharm Inc',
        lastPrice: 103.28,
        priceChange: -0.76,
        percentChange: -0.0073,
        highPrice: 103.39,
        lowPrice: 102.97,
        volume: 3606,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AMAT',
      symbolName: 'Applied Materials',
      lastPrice: '62.66',
      priceChange: '-0.53',
      percentChange: '-0.84%',
      highPrice: '62.86',
      lowPrice: '62.42',
      volume: '17,233',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AMAT',
        symbolName: 'Applied Materials',
        lastPrice: 62.66,
        priceChange: -0.53,
        percentChange: -0.0084,
        highPrice: 62.86,
        lowPrice: 62.42,
        volume: 17233,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AMCR',
      symbolName: 'Amcor Plc',
      lastPrice: '10.82',
      priceChange: '-0.19',
      percentChange: '-1.73%',
      highPrice: '10.87',
      lowPrice: '10.82',
      volume: '5,094',
      tradeTime: '09:32 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AMCR',
        symbolName: 'Amcor Plc',
        lastPrice: 10.82,
        priceChange: -0.19,
        percentChange: -0.0173,
        highPrice: 10.87,
        lowPrice: 10.82,
        volume: 5094,
        tradeTime: 1581085920,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AMD',
      symbolName: 'Adv Micro Devices',
      lastPrice: '48.92',
      priceChange: '-0.40',
      percentChange: '-0.81%',
      highPrice: '49.10',
      lowPrice: '48.63',
      volume: '437,177',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AMD',
        symbolName: 'Adv Micro Devices',
        lastPrice: 48.92,
        priceChange: -0.4,
        percentChange: -0.008100000000000001,
        highPrice: 49.1,
        lowPrice: 48.63,
        volume: 437177,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AME',
      symbolName: 'Amtek Inc',
      lastPrice: '98.10',
      priceChange: '-0.58',
      percentChange: '-0.59%',
      highPrice: '98.20',
      lowPrice: '98.10',
      volume: '1,667',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AME',
        symbolName: 'Amtek Inc',
        lastPrice: 98.1,
        priceChange: -0.58,
        percentChange: -0.0059,
        highPrice: 98.2,
        lowPrice: 98.1,
        volume: 1667,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AMGN',
      symbolName: 'Amgen Inc',
      lastPrice: '231.18',
      priceChange: '-0.27',
      percentChange: '-0.12%',
      highPrice: '231.18',
      lowPrice: '231.01',
      volume: '429',
      tradeTime: '09:33 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AMGN',
        symbolName: 'Amgen Inc',
        lastPrice: 231.18,
        priceChange: -0.27,
        percentChange: -0.0012,
        highPrice: 231.18,
        lowPrice: 231.01,
        volume: 429,
        tradeTime: 1581085980,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AMP',
      symbolName: 'Ameriprise Financial Services',
      lastPrice: '174.32',
      priceChange: '-1.59',
      percentChange: '-0.90%',
      highPrice: '174.42',
      lowPrice: '174.32',
      volume: '634',
      tradeTime: '09:34 ET',
      symbolCode: 'UIT',
      hasOptions: 'Yes',
      symbolType: 11,
      raw: {
        symbol: 'AMP',
        symbolName: 'Ameriprise Financial Services',
        lastPrice: 174.32,
        priceChange: -1.59,
        percentChange: -0.009000000000000001,
        highPrice: 174.42,
        lowPrice: 174.32,
        volume: 634,
        tradeTime: 1581086040,
        symbolCode: 'UIT',
        hasOptions: true,
        symbolType: 11
      }
    },
    {
      symbol: 'AMT',
      symbolName: 'American Tower Corp',
      lastPrice: '238.72',
      priceChange: '+0.91',
      percentChange: '+0.38%',
      highPrice: '238.72',
      lowPrice: '238.37',
      volume: '16,984',
      tradeTime: '09:31 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AMT',
        symbolName: 'American Tower Corp',
        lastPrice: 238.72,
        priceChange: 0.9099999999999966,
        percentChange: 0.0038265842479290046,
        highPrice: 238.72,
        lowPrice: 238.37,
        volume: 16984,
        tradeTime: 1581085861,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AMZN',
      symbolName: 'Amazon.com Inc',
      lastPrice: '2,039.99',
      priceChange: '-10.24',
      percentChange: '-0.50%',
      highPrice: '2,045.73',
      lowPrice: '2,039.10',
      volume: '34,085',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AMZN',
        symbolName: 'Amazon.com Inc',
        lastPrice: 2039.99,
        priceChange: -10.24,
        percentChange: -0.005,
        highPrice: 2045.73,
        lowPrice: 2039.1,
        volume: 34085,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ANET',
      symbolName: 'Arista Networks Inc',
      lastPrice: '231.50',
      priceChange: '-1.02',
      percentChange: '-0.44%',
      highPrice: '231.50',
      lowPrice: '231.50',
      volume: '370',
      tradeTime: '09:32 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ANET',
        symbolName: 'Arista Networks Inc',
        lastPrice: 231.5,
        priceChange: -1.02,
        percentChange: -0.0044,
        highPrice: 231.5,
        lowPrice: 231.5,
        volume: 370,
        tradeTime: 1581085920,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ANSS',
      symbolName: 'Ansys Inc',
      lastPrice: '285.01',
      priceChange: '-0.87',
      percentChange: '-0.30%',
      highPrice: '285.44',
      lowPrice: '285.01',
      volume: '8,516',
      tradeTime: '09:30 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ANSS',
        symbolName: 'Ansys Inc',
        lastPrice: 285.01,
        priceChange: -0.8700000000000045,
        percentChange: -0.003043234923744245,
        highPrice: 285.44,
        lowPrice: 285.01,
        volume: 8516,
        tradeTime: 1581085854,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ANTM',
      symbolName: 'Anthem Inc',
      lastPrice: '281.50',
      priceChange: '-0.83',
      percentChange: '-0.29%',
      highPrice: '281.50',
      lowPrice: '281.50',
      volume: '2,032',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ANTM',
        symbolName: 'Anthem Inc',
        lastPrice: 281.5,
        priceChange: -0.83,
        percentChange: -0.0029,
        highPrice: 281.5,
        lowPrice: 281.5,
        volume: 2032,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AON',
      symbolName: 'AON Plc',
      lastPrice: '229.43',
      priceChange: '-0.17',
      percentChange: '-0.07%',
      highPrice: '229.87',
      lowPrice: '229.35',
      volume: '7,314',
      tradeTime: '09:30 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AON',
        symbolName: 'AON Plc',
        lastPrice: 229.43,
        priceChange: -0.1699999999999875,
        percentChange: -0.0007404181184668445,
        highPrice: 229.87,
        lowPrice: 229.35,
        volume: 7314,
        tradeTime: 1581085858,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AOS',
      symbolName: 'Smith [A.O.] Corp',
      lastPrice: '42.84',
      priceChange: '-0.46',
      percentChange: '-1.06%',
      highPrice: '42.84',
      lowPrice: '42.84',
      volume: '1,227',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AOS',
        symbolName: 'Smith [A.O.] Corp',
        lastPrice: 42.84,
        priceChange: -0.46,
        percentChange: -0.0106,
        highPrice: 42.84,
        lowPrice: 42.84,
        volume: 1227,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'APA',
      symbolName: 'Apache Corp',
      lastPrice: '28.41',
      priceChange: '-0.53',
      percentChange: '-1.83%',
      highPrice: '28.44',
      lowPrice: '28.13',
      volume: '4,739',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'APA',
        symbolName: 'Apache Corp',
        lastPrice: 28.41,
        priceChange: -0.53,
        percentChange: -0.0183,
        highPrice: 28.44,
        lowPrice: 28.13,
        volume: 4739,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'APD',
      symbolName: 'Air Products and Chemicals',
      lastPrice: '249.84',
      priceChange: '-1.22',
      percentChange: '-0.49%',
      highPrice: '250.40',
      lowPrice: '249.77',
      volume: '1,104',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'APD',
        symbolName: 'Air Products and Chemicals',
        lastPrice: 249.84,
        priceChange: -1.22,
        percentChange: -0.0049,
        highPrice: 250.4,
        lowPrice: 249.77,
        volume: 1104,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'APH',
      symbolName: 'Amphenol Corp',
      lastPrice: '103.04',
      priceChange: '-0.92',
      percentChange: '-0.88%',
      highPrice: '103.23',
      lowPrice: '103.04',
      volume: '17,603',
      tradeTime: '09:31 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'APH',
        symbolName: 'Amphenol Corp',
        lastPrice: 103.04,
        priceChange: -0.9199999999999875,
        percentChange: -0.008849557522123774,
        highPrice: 103.23,
        lowPrice: 103.04,
        volume: 17603,
        tradeTime: 1581085860,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'APTV',
      symbolName: 'Aptiv Plc',
      lastPrice: '87.25',
      priceChange: '-0.99',
      percentChange: '-1.12%',
      highPrice: '87.32',
      lowPrice: '87.10',
      volume: '6,548',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'APTV',
        symbolName: 'Aptiv Plc',
        lastPrice: 87.25,
        priceChange: -0.99,
        percentChange: -0.011200000000000002,
        highPrice: 87.32,
        lowPrice: 87.1,
        volume: 6548,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ARE',
      symbolName: 'Alexandria Real Estate Equities',
      lastPrice: '167.98',
      priceChange: '+0.14',
      percentChange: '+0.08%',
      highPrice: '167.98',
      lowPrice: '167.98',
      volume: '102',
      tradeTime: '09:32 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ARE',
        symbolName: 'Alexandria Real Estate Equities',
        lastPrice: 167.98,
        priceChange: 0.14,
        percentChange: 0.0008,
        highPrice: 167.98,
        lowPrice: 167.98,
        volume: 102,
        tradeTime: 1581085920,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ARNC',
      symbolName: 'Arconic Inc',
      lastPrice: '31.17',
      priceChange: '-0.23',
      percentChange: '-0.73%',
      highPrice: '31.27',
      lowPrice: '31.14',
      volume: '1,832',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ARNC',
        symbolName: 'Arconic Inc',
        lastPrice: 31.17,
        priceChange: -0.23,
        percentChange: -0.0073,
        highPrice: 31.27,
        lowPrice: 31.14,
        volume: 1832,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ATO',
      symbolName: 'Atmos Energy Corp',
      lastPrice: '117.59',
      priceChange: '-0.07',
      percentChange: '-0.06%',
      highPrice: '117.88',
      lowPrice: '117.15',
      volume: '9,782',
      tradeTime: '09:30 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ATO',
        symbolName: 'Atmos Energy Corp',
        lastPrice: 117.59,
        priceChange: -0.06999999999999318,
        percentChange: -0.0005949345571986502,
        highPrice: 117.88,
        lowPrice: 117.15,
        volume: 9782,
        tradeTime: 1581085831,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'ATVI',
      symbolName: 'Activision Blizzard',
      lastPrice: '61.15',
      priceChange: '+0.89',
      percentChange: '+1.48%',
      highPrice: '61.55',
      lowPrice: '60.60',
      volume: '90,425',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'ATVI',
        symbolName: 'Activision Blizzard',
        lastPrice: 61.15,
        priceChange: 0.89,
        percentChange: 0.0148,
        highPrice: 61.55,
        lowPrice: 60.6,
        volume: 90425,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AVB',
      symbolName: 'Avalonbay Communities',
      lastPrice: '219.74',
      priceChange: '+0.61',
      percentChange: '+0.28%',
      highPrice: '219.82',
      lowPrice: '219.74',
      volume: '4,118',
      tradeTime: '09:33 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AVB',
        symbolName: 'Avalonbay Communities',
        lastPrice: 219.74,
        priceChange: 0.61,
        percentChange: 0.0028000000000000004,
        highPrice: 219.82,
        lowPrice: 219.74,
        volume: 4118,
        tradeTime: 1581085980,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AVGO',
      symbolName: 'Broadcom Ltd',
      lastPrice: '317.43',
      priceChange: '-2.26',
      percentChange: '-0.71%',
      highPrice: '317.77',
      lowPrice: '317.19',
      volume: '6,292',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AVGO',
        symbolName: 'Broadcom Ltd',
        lastPrice: 317.43,
        priceChange: -2.26,
        percentChange: -0.0070999999999999995,
        highPrice: 317.77,
        lowPrice: 317.19,
        volume: 6292,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AVY',
      symbolName: 'Avery Dennison Corp',
      lastPrice: '137.67',
      priceChange: '-1.22',
      percentChange: '-0.88%',
      highPrice: '138.40',
      lowPrice: '137.67',
      volume: '4,774',
      tradeTime: '09:31 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AVY',
        symbolName: 'Avery Dennison Corp',
        lastPrice: 137.67,
        priceChange: -1.2199999999999989,
        percentChange: -0.008783929728562165,
        highPrice: 138.4,
        lowPrice: 137.67,
        volume: 4774,
        tradeTime: 1581085863,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AWK',
      symbolName: 'American Water Works',
      lastPrice: '135.80',
      priceChange: '+0.80',
      percentChange: '+0.59%',
      highPrice: '135.84',
      lowPrice: '135.73',
      volume: '1,957',
      tradeTime: '09:33 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AWK',
        symbolName: 'American Water Works',
        lastPrice: 135.8,
        priceChange: 0.8,
        percentChange: 0.0059,
        highPrice: 135.84,
        lowPrice: 135.73,
        volume: 1957,
        tradeTime: 1581085980,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AXP',
      symbolName: 'American Express Company',
      lastPrice: '131.46',
      priceChange: '-1.79',
      percentChange: '-1.35%',
      highPrice: '131.54',
      lowPrice: '131.46',
      volume: '2,231',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AXP',
        symbolName: 'American Express Company',
        lastPrice: 131.46,
        priceChange: -1.79,
        percentChange: -0.013500000000000002,
        highPrice: 131.54,
        lowPrice: 131.46,
        volume: 2231,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'AZO',
      symbolName: 'Autozone',
      lastPrice: '1,057.06',
      priceChange: '-5.25',
      percentChange: '-0.49%',
      highPrice: '1,057.06',
      lowPrice: '1,057.06',
      volume: '998',
      tradeTime: '09:30 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'AZO',
        symbolName: 'Autozone',
        lastPrice: 1057.06,
        priceChange: -5.25,
        percentChange: -0.004942060227240636,
        highPrice: 1057.06,
        lowPrice: 1057.06,
        volume: 998,
        tradeTime: 1581085853,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BA',
      symbolName: 'Boeing Company',
      lastPrice: '337.68',
      priceChange: '-3.75',
      percentChange: '-1.10%',
      highPrice: '340.50',
      lowPrice: '337.65',
      volume: '131,843',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BA',
        symbolName: 'Boeing Company',
        lastPrice: 337.68,
        priceChange: -3.75,
        percentChange: -0.011000000000000001,
        highPrice: 340.5,
        lowPrice: 337.65,
        volume: 131843,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BAC',
      symbolName: 'Bank of America Corp',
      lastPrice: '34.33',
      priceChange: '-0.34',
      percentChange: '-0.99%',
      highPrice: '34.41',
      lowPrice: '34.28',
      volume: '978,338',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BAC',
        symbolName: 'Bank of America Corp',
        lastPrice: 34.33,
        priceChange: -0.34,
        percentChange: -0.009899999999999999,
        highPrice: 34.41,
        lowPrice: 34.28,
        volume: 978338,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BAX',
      symbolName: 'Baxter International Inc',
      lastPrice: '92.50',
      priceChange: '-0.81',
      percentChange: '-0.86%',
      highPrice: '92.62',
      lowPrice: '92.50',
      volume: '701',
      tradeTime: '09:33 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BAX',
        symbolName: 'Baxter International Inc',
        lastPrice: 92.5,
        priceChange: -0.81,
        percentChange: -0.0086,
        highPrice: 92.62,
        lowPrice: 92.5,
        volume: 701,
        tradeTime: 1581085980,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BBY',
      symbolName: 'Best Buy Company',
      lastPrice: '88.05',
      priceChange: '-0.59',
      percentChange: '-0.67%',
      highPrice: '88.05',
      lowPrice: '88.04',
      volume: '804',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BBY',
        symbolName: 'Best Buy Company',
        lastPrice: 88.05,
        priceChange: -0.59,
        percentChange: -0.0067,
        highPrice: 88.05,
        lowPrice: 88.04,
        volume: 804,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BDX',
      symbolName: 'Becton Dickinson and Company',
      lastPrice: '250.04',
      priceChange: '-2.21',
      percentChange: '-0.88%',
      highPrice: '252.01',
      lowPrice: '249.86',
      volume: '95,664',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BDX',
        symbolName: 'Becton Dickinson and Company',
        lastPrice: 250.04,
        priceChange: -2.21,
        percentChange: -0.0088,
        highPrice: 252.01,
        lowPrice: 249.86,
        volume: 95664,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BEN',
      symbolName: 'Franklin Resources',
      lastPrice: '25.83',
      priceChange: '-0.25',
      percentChange: '-0.96%',
      highPrice: '25.83',
      lowPrice: '25.72',
      volume: '3,092',
      tradeTime: '09:34 ET',
      symbolCode: 'UIT',
      hasOptions: 'Yes',
      symbolType: 11,
      raw: {
        symbol: 'BEN',
        symbolName: 'Franklin Resources',
        lastPrice: 25.83,
        priceChange: -0.25,
        percentChange: -0.0096,
        highPrice: 25.83,
        lowPrice: 25.72,
        volume: 3092,
        tradeTime: 1581086040,
        symbolCode: 'UIT',
        hasOptions: true,
        symbolType: 11
      }
    },
    {
      symbol: 'BF.B',
      symbolName: 'Brown Forman Inc Cl B',
      lastPrice: '69.13',
      priceChange: '-0.13',
      percentChange: '-0.19%',
      highPrice: '69.38',
      lowPrice: '68.93',
      volume: '9,928',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'No',
      symbolType: 1,
      raw: {
        symbol: 'BF.B',
        symbolName: 'Brown Forman Inc Cl B',
        lastPrice: 69.13,
        priceChange: -0.13,
        percentChange: -0.0019,
        highPrice: 69.38,
        lowPrice: 68.93,
        volume: 9928,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: false,
        symbolType: 1
      }
    },
    {
      symbol: 'BIIB',
      symbolName: 'Biogen Inc',
      lastPrice: '337.62',
      priceChange: '+0.38',
      percentChange: '+0.11%',
      highPrice: '337.62',
      lowPrice: '334.85',
      volume: '140,002',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BIIB',
        symbolName: 'Biogen Inc',
        lastPrice: 337.62,
        priceChange: 0.38,
        percentChange: 0.0011,
        highPrice: 337.62,
        lowPrice: 334.85,
        volume: 140002,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BK',
      symbolName: 'Bank of New York Mellon Corp',
      lastPrice: '47.21',
      priceChange: '-0.33',
      percentChange: '-0.69%',
      highPrice: '47.27',
      lowPrice: '47.21',
      volume: '2,165',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BK',
        symbolName: 'Bank of New York Mellon Corp',
        lastPrice: 47.21,
        priceChange: -0.33,
        percentChange: -0.0069,
        highPrice: 47.27,
        lowPrice: 47.21,
        volume: 2165,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BKNG',
      symbolName: 'Booking Holdings Inc',
      lastPrice: '1,952.66',
      priceChange: '-8.24',
      percentChange: '-0.42%',
      highPrice: '1,954.74',
      lowPrice: '1,951.37',
      volume: '1,380',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BKNG',
        symbolName: 'Booking Holdings Inc',
        lastPrice: 1952.66,
        priceChange: -8.24,
        percentChange: -0.0042,
        highPrice: 1954.74,
        lowPrice: 1951.37,
        volume: 1380,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BKR',
      symbolName: 'Baker Hughes A Ge Co. Cl A',
      lastPrice: '22.07',
      priceChange: '-0.16',
      percentChange: '-0.74%',
      highPrice: '22.07',
      lowPrice: '21.88',
      volume: '52,579',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BKR',
        symbolName: 'Baker Hughes A Ge Co. Cl A',
        lastPrice: 22.07,
        priceChange: -0.16,
        percentChange: -0.0074,
        highPrice: 22.07,
        lowPrice: 21.88,
        volume: 52579,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BLK',
      symbolName: 'Blackrock',
      lastPrice: '550.00',
      priceChange: '-4.67',
      percentChange: '-0.84%',
      highPrice: '550.03',
      lowPrice: '550.00',
      volume: '9,682',
      tradeTime: '09:31 ET',
      symbolCode: 'UIT',
      hasOptions: 'Yes',
      symbolType: 11,
      raw: {
        symbol: 'BLK',
        symbolName: 'Blackrock',
        lastPrice: 550,
        priceChange: -4.669999999999959,
        percentChange: -0.008419420556366776,
        highPrice: 550.03,
        lowPrice: 550,
        volume: 9682,
        tradeTime: 1581085860,
        symbolCode: 'UIT',
        hasOptions: true,
        symbolType: 11
      }
    },
    {
      symbol: 'BLL',
      symbolName: 'Ball Corp',
      lastPrice: '77.57',
      priceChange: '-0.43',
      percentChange: '-0.55%',
      highPrice: '77.59',
      lowPrice: '77.15',
      volume: '8,584',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BLL',
        symbolName: 'Ball Corp',
        lastPrice: 77.57,
        priceChange: -0.43,
        percentChange: -0.0055000000000000005,
        highPrice: 77.59,
        lowPrice: 77.15,
        volume: 8584,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BMY',
      symbolName: 'Bristol-Myers Squibb Company',
      lastPrice: '66.60',
      priceChange: '-0.50',
      percentChange: '-0.75%',
      highPrice: '67.00',
      lowPrice: '66.60',
      volume: '81,222',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BMY',
        symbolName: 'Bristol-Myers Squibb Company',
        lastPrice: 66.6,
        priceChange: -0.5,
        percentChange: -0.0075,
        highPrice: 67,
        lowPrice: 66.6,
        volume: 81222,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BR',
      symbolName: 'Broadridge Financial Solutions Llc',
      lastPrice: '118.66',
      priceChange: '-1.07',
      percentChange: '-0.89%',
      highPrice: '119.36',
      lowPrice: '118.66',
      volume: '9,871',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BR',
        symbolName: 'Broadridge Financial Solutions Llc',
        lastPrice: 118.66,
        priceChange: -1.07,
        percentChange: -0.0089,
        highPrice: 119.36,
        lowPrice: 118.66,
        volume: 9871,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BRK.B',
      symbolName: 'Berkshire Hathaway Cl B',
      lastPrice: '227.30',
      priceChange: '-2.31',
      percentChange: '-1.01%',
      highPrice: '228.11',
      lowPrice: '227.26',
      volume: '5,726',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'No',
      symbolType: 1,
      raw: {
        symbol: 'BRK.B',
        symbolName: 'Berkshire Hathaway Cl B',
        lastPrice: 227.3,
        priceChange: -2.31,
        percentChange: -0.0101,
        highPrice: 228.11,
        lowPrice: 227.26,
        volume: 5726,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: false,
        symbolType: 1
      }
    },
    {
      symbol: 'BSX',
      symbolName: 'Boston Scientific Corp',
      lastPrice: '42.81',
      priceChange: '-0.19',
      percentChange: '-0.45%',
      highPrice: '42.94',
      lowPrice: '42.78',
      volume: '8,690',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BSX',
        symbolName: 'Boston Scientific Corp',
        lastPrice: 42.81,
        priceChange: -0.19,
        percentChange: -0.0045000000000000005,
        highPrice: 42.94,
        lowPrice: 42.78,
        volume: 8690,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BWA',
      symbolName: 'Borgwarner Inc',
      lastPrice: '33.46',
      priceChange: '-0.30',
      percentChange: '-0.89%',
      highPrice: '33.53',
      lowPrice: '33.40',
      volume: '24,217',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BWA',
        symbolName: 'Borgwarner Inc',
        lastPrice: 33.46,
        priceChange: -0.3,
        percentChange: -0.0089,
        highPrice: 33.53,
        lowPrice: 33.4,
        volume: 24217,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'BXP',
      symbolName: 'Boston Properties',
      lastPrice: '144.28',
      priceChange: '-0.10',
      percentChange: '-0.07%',
      highPrice: '144.28',
      lowPrice: '144.28',
      volume: '3,488',
      tradeTime: '09:30 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'BXP',
        symbolName: 'Boston Properties',
        lastPrice: 144.28,
        priceChange: -0.09999999999999432,
        percentChange: -0.0006926167059149073,
        highPrice: 144.28,
        lowPrice: 144.28,
        volume: 3488,
        tradeTime: 1581085830,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'C',
      symbolName: 'Citigroup Inc',
      lastPrice: '78.26',
      priceChange: '-0.71',
      percentChange: '-0.90%',
      highPrice: '78.54',
      lowPrice: '78.10',
      volume: '65,646',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'C',
        symbolName: 'Citigroup Inc',
        lastPrice: 78.26,
        priceChange: -0.71,
        percentChange: -0.009000000000000001,
        highPrice: 78.54,
        lowPrice: 78.1,
        volume: 65646,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CAG',
      symbolName: 'Conagra Brands Inc',
      lastPrice: '31.94',
      priceChange: '-0.15',
      percentChange: '-0.47%',
      highPrice: '32.00',
      lowPrice: '31.94',
      volume: '3,915',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CAG',
        symbolName: 'Conagra Brands Inc',
        lastPrice: 31.94,
        priceChange: -0.15,
        percentChange: -0.004699999999999999,
        highPrice: 32,
        lowPrice: 31.94,
        volume: 3915,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CAH',
      symbolName: 'Cardinal Health',
      lastPrice: '59.93',
      priceChange: '+1.67',
      percentChange: '+2.87%',
      highPrice: '59.94',
      lowPrice: '59.06',
      volume: '13,098',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CAH',
        symbolName: 'Cardinal Health',
        lastPrice: 59.93,
        priceChange: 1.67,
        percentChange: 0.0287,
        highPrice: 59.94,
        lowPrice: 59.06,
        volume: 13098,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CAT',
      symbolName: 'Caterpillar Inc',
      lastPrice: '135.73',
      priceChange: '-1.52',
      percentChange: '-1.11%',
      highPrice: '136.43',
      lowPrice: '135.29',
      volume: '3,882',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CAT',
        symbolName: 'Caterpillar Inc',
        lastPrice: 135.73,
        priceChange: -1.52,
        percentChange: -0.0111,
        highPrice: 136.43,
        lowPrice: 135.29,
        volume: 3882,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CB',
      symbolName: 'Chubb Ltd',
      lastPrice: '162.70',
      priceChange: '-0.52',
      percentChange: '-0.32%',
      highPrice: '162.70',
      lowPrice: '162.34',
      volume: '600',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CB',
        symbolName: 'Chubb Ltd',
        lastPrice: 162.7,
        priceChange: -0.52,
        percentChange: -0.0032,
        highPrice: 162.7,
        lowPrice: 162.34,
        volume: 600,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CBOE',
      symbolName: 'CBOE Global Markets Inc',
      lastPrice: '126.28',
      priceChange: '-1.65',
      percentChange: '-1.29%',
      highPrice: '126.97',
      lowPrice: '126.28',
      volume: '5,197',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CBOE',
        symbolName: 'CBOE Global Markets Inc',
        lastPrice: 126.28,
        priceChange: -1.65,
        percentChange: -0.0129,
        highPrice: 126.97,
        lowPrice: 126.28,
        volume: 5197,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CBRE',
      symbolName: 'CBRE Group Inc',
      lastPrice: '63.45',
      priceChange: '-0.43',
      percentChange: '-0.67%',
      highPrice: '63.45',
      lowPrice: '63.45',
      volume: '100',
      tradeTime: '09:33 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CBRE',
        symbolName: 'CBRE Group Inc',
        lastPrice: 63.45,
        priceChange: -0.43,
        percentChange: -0.0067,
        highPrice: 63.45,
        lowPrice: 63.45,
        volume: 100,
        tradeTime: 1581085980,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CCI',
      symbolName: 'Crown Castle International Corp',
      lastPrice: '151.00',
      priceChange: '+0.50',
      percentChange: '+0.33%',
      highPrice: '151.06',
      lowPrice: '151.00',
      volume: '13,663',
      tradeTime: '09:31 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CCI',
        symbolName: 'Crown Castle International Corp',
        lastPrice: 151,
        priceChange: 0.5,
        percentChange: 0.0033222591362126247,
        highPrice: 151.06,
        lowPrice: 151,
        volume: 13663,
        tradeTime: 1581085860,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CCL',
      symbolName: 'Carnival Corp',
      lastPrice: '42.74',
      priceChange: '-1.04',
      percentChange: '-2.38%',
      highPrice: '43.01',
      lowPrice: '42.74',
      volume: '81,798',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CCL',
        symbolName: 'Carnival Corp',
        lastPrice: 42.74,
        priceChange: -1.04,
        percentChange: -0.023799999999999998,
        highPrice: 43.01,
        lowPrice: 42.74,
        volume: 81798,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CDNS',
      symbolName: 'Cadence Design Sys',
      lastPrice: '73.94',
      priceChange: '-0.60',
      percentChange: '-0.80%',
      highPrice: '74.02',
      lowPrice: '73.94',
      volume: '335',
      tradeTime: '09:32 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CDNS',
        symbolName: 'Cadence Design Sys',
        lastPrice: 73.94,
        priceChange: -0.6,
        percentChange: -0.008,
        highPrice: 74.02,
        lowPrice: 73.94,
        volume: 335,
        tradeTime: 1581085920,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CDW',
      symbolName: 'CDW Corp',
      lastPrice: '134.45',
      priceChange: '-0.19',
      percentChange: '-0.14%',
      highPrice: '134.45',
      lowPrice: '134.45',
      volume: '111',
      tradeTime: '09:31 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CDW',
        symbolName: 'CDW Corp',
        lastPrice: 134.45,
        priceChange: -0.19,
        percentChange: -0.0014000000000000002,
        highPrice: 134.45,
        lowPrice: 134.45,
        volume: 111,
        tradeTime: 1581085860,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CE',
      symbolName: 'Celanese Corp',
      lastPrice: '107.94',
      priceChange: '-1.52',
      percentChange: '-1.39%',
      highPrice: '107.94',
      lowPrice: '107.71',
      volume: '533',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CE',
        symbolName: 'Celanese Corp',
        lastPrice: 107.94,
        priceChange: -1.52,
        percentChange: -0.0139,
        highPrice: 107.94,
        lowPrice: 107.71,
        volume: 533,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CERN',
      symbolName: 'Cerner Corp',
      lastPrice: '78.72',
      priceChange: '-0.22',
      percentChange: '-0.28%',
      highPrice: '78.91',
      lowPrice: '78.60',
      volume: '1,445',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CERN',
        symbolName: 'Cerner Corp',
        lastPrice: 78.72,
        priceChange: -0.22,
        percentChange: -0.0028000000000000004,
        highPrice: 78.91,
        lowPrice: 78.6,
        volume: 1445,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CF',
      symbolName: 'Cf Industries Holdings',
      lastPrice: '41.97',
      priceChange: '-0.28',
      percentChange: '-0.66%',
      highPrice: '41.97',
      lowPrice: '41.97',
      volume: '212',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CF',
        symbolName: 'Cf Industries Holdings',
        lastPrice: 41.97,
        priceChange: -0.28,
        percentChange: -0.0066,
        highPrice: 41.97,
        lowPrice: 41.97,
        volume: 212,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CFG',
      symbolName: 'Citizens Financial Group Inc/Ri',
      lastPrice: '38.36',
      priceChange: '-0.36',
      percentChange: '-0.93%',
      highPrice: '38.46',
      lowPrice: '38.32',
      volume: '4,121',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CFG',
        symbolName: 'Citizens Financial Group Inc/Ri',
        lastPrice: 38.36,
        priceChange: -0.36,
        percentChange: -0.009300000000000001,
        highPrice: 38.46,
        lowPrice: 38.32,
        volume: 4121,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CHD',
      symbolName: 'Church & Dwight Company',
      lastPrice: '73.93',
      priceChange: '-0.03',
      percentChange: '-0.05%',
      highPrice: '74.62',
      lowPrice: '73.82',
      volume: '15,942',
      tradeTime: '09:32 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CHD',
        symbolName: 'Church & Dwight Company',
        lastPrice: 73.93,
        priceChange: -0.03,
        percentChange: -0.0005,
        highPrice: 74.62,
        lowPrice: 73.82,
        volume: 15942,
        tradeTime: 1581085920,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CHRW',
      symbolName: 'C.H. Robinson Ww',
      lastPrice: '73.93',
      priceChange: '+0.35',
      percentChange: '+0.48%',
      highPrice: '73.98',
      lowPrice: '73.74',
      volume: '905',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CHRW',
        symbolName: 'C.H. Robinson Ww',
        lastPrice: 73.93,
        priceChange: 0.35,
        percentChange: 0.0048,
        highPrice: 73.98,
        lowPrice: 73.74,
        volume: 905,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CHTR',
      symbolName: 'Charter Communicatio',
      lastPrice: '523.97',
      priceChange: '-2.59',
      percentChange: '-0.49%',
      highPrice: '526.55',
      lowPrice: '523.86',
      volume: '7,417',
      tradeTime: '09:30 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CHTR',
        symbolName: 'Charter Communicatio',
        lastPrice: 523.97,
        priceChange: -2.589999999999918,
        percentChange: -0.004918717714980095,
        highPrice: 526.55,
        lowPrice: 523.86,
        volume: 7417,
        tradeTime: 1581085858,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CI',
      symbolName: 'Cigna Corp',
      lastPrice: '212.21',
      priceChange: '+0.35',
      percentChange: '+0.17%',
      highPrice: '212.69',
      lowPrice: '211.46',
      volume: '2,100',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CI',
        symbolName: 'Cigna Corp',
        lastPrice: 212.21,
        priceChange: 0.35,
        percentChange: 0.0017000000000000001,
        highPrice: 212.69,
        lowPrice: 211.46,
        volume: 2100,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CINF',
      symbolName: 'Cincinnati Financial',
      lastPrice: '112.69',
      priceChange: '-0.15',
      percentChange: '-0.13%',
      highPrice: '112.69',
      lowPrice: '112.69',
      volume: '351',
      tradeTime: '09:33 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CINF',
        symbolName: 'Cincinnati Financial',
        lastPrice: 112.69,
        priceChange: -0.15,
        percentChange: -0.0013,
        highPrice: 112.69,
        lowPrice: 112.69,
        volume: 351,
        tradeTime: 1581085980,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CL',
      symbolName: 'Colgate-Palmolive Company',
      lastPrice: '76.17',
      priceChange: '-0.14',
      percentChange: '-0.18%',
      highPrice: '76.40',
      lowPrice: '76.00',
      volume: '106,247',
      tradeTime: '09:33 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CL',
        symbolName: 'Colgate-Palmolive Company',
        lastPrice: 76.17,
        priceChange: -0.14,
        percentChange: -0.0018,
        highPrice: 76.4,
        lowPrice: 76,
        volume: 106247,
        tradeTime: 1581085980,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CLX',
      symbolName: 'Clorox Company',
      lastPrice: '164.42',
      priceChange: '-0.65',
      percentChange: '-0.39%',
      highPrice: '165.15',
      lowPrice: '164.42',
      volume: '26,715',
      tradeTime: '09:31 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CLX',
        symbolName: 'Clorox Company',
        lastPrice: 164.42,
        priceChange: -0.6500000000000057,
        percentChange: -0.003937723390076971,
        highPrice: 165.15,
        lowPrice: 164.42,
        volume: 26715,
        tradeTime: 1581085862,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    },
    {
      symbol: 'CMA',
      symbolName: 'Comerica Inc',
      lastPrice: '62.50',
      priceChange: '-0.77',
      percentChange: '-1.22%',
      highPrice: '62.64',
      lowPrice: '62.50',
      volume: '909',
      tradeTime: '09:34 ET',
      symbolCode: 'STK',
      hasOptions: 'Yes',
      symbolType: 1,
      raw: {
        symbol: 'CMA',
        symbolName: 'Comerica Inc',
        lastPrice: 62.5,
        priceChange: -0.77,
        percentChange: -0.012199999999999999,
        highPrice: 62.64,
        lowPrice: 62.5,
        volume: 909,
        tradeTime: 1581086040,
        symbolCode: 'STK',
        hasOptions: true,
        symbolType: 1
      }
    }
  ],
  meta: {
    field: {
      shortName: {
        symbol: 'Symbol',
        symbolName: 'Name',
        lastPrice: 'Last',
        priceChange: 'Change',
        percentChange: '%Chg',
        highPrice: 'High',
        lowPrice: 'Low',
        volume: 'Volume',
        tradeTime: 'Time',
        symbolCode: 'Symbol Code',
        hasOptions: 'Options',
        symbolType: 'Type'
      },
      description: {
        symbol: '',
        symbolName: '',
        lastPrice: 'The last trade price.',
        priceChange:
          "The difference between the current price and the previous day's settlement price.",
        percentChange:
          "The difference between the current price and the previous day's settlement price expressed as a percentage.",
        highPrice: 'The highest trade price for the day.',
        lowPrice: 'The lowest trade price for the day.',
        volume:
          'The total number of shares or futures contracts traded for the day.',
        tradeTime: '',
        symbolCode: '',
        hasOptions: 'The symbol either has options available, or does not.',
        symbolType:
          'A Call option gives you the right to buy a stock and a Put option gives you the right to sell a stock.'
      },
      type: {
        symbol: 'string',
        symbolName: 'string',
        lastPrice: 'price',
        priceChange: 'priceChange',
        percentChange: 'percentChange',
        highPrice: 'price',
        lowPrice: 'price',
        volume: 'integer',
        tradeTime: 'time',
        symbolCode: 'string',
        hasOptions: 'boolean',
        symbolType: 'string'
      }
    }
  }
};
 export default symbols;
